import { useEffect, useState } from "react"
import { REMOVE_SESSION_DATA, createAppSession, triggerEvents } from "../utils/eventUtils"

export const useSession = () => {
	const [sessionId, setSessionId] = useState<string>()

	useEffect(() => {
		const id = createAppSession()
		setSessionId(id)

		let interval: any

		interval = setInterval(() => {
			triggerEvents()
		}, 10 * 1000)

		window.addEventListener("blur", () => {
			triggerEvents()
		})

		window.addEventListener("beforeunload", () => {
			triggerEvents(REMOVE_SESSION_DATA)
		})

		return () => {
			window.removeEventListener("blur", () => {
				triggerEvents()
			})
			window.removeEventListener("beforeunload", () => {
				triggerEvents()
			})
			clearInterval(interval)
		}
	}, [])
	return sessionId
}
